export default __webpack_public_path__ + "static/client_logo-316cd3cf02d812c3d6b2ea5808897f1b.png";